module.exports = __webpack_public_path__ + "img/Icon_View.54bbcda9.svg";